module.exports = __webpack_public_path__ + "img/icon_head.28ffc141.jpg";